import React from "react";
import { Title } from "../Title";
import { ArticleCard } from "./ArticleCard";
import articleThumb1 from "../../assets/images/articleThumb-1.png";
import articleThumb2 from "../../assets/images/articleThumb-2.png";
import articleThumb3 from "../../assets/images/articleThumb-3.png";
import articleThumb4 from "../../assets/images/articleThumb-4.png";
import "./style.css";

export const News = ({ className, content }) => {
  const news = content.sections.news;
  const thumbs = [articleThumb1, articleThumb2, articleThumb3, articleThumb4];

  return (
    <section id="news" className={`news ${className}`}>
      <div className="container">
        <Title
          title={news.title}
          description={news.description}
        />

        <div className="row justify-content-between">
          {content.news.map((article, index) => (
            <ArticleCard
              key={`${article.title}-${index}`}
              className="col-xl-3 col-6"
              thumb={thumbs[index]}
              title={article.title}
              description={article.description}
              category={news.category}
              date={news.date}
              viewMoreLabel={content.common.viewMore}
            />
          ))}
        </div>

        <button className="view-more-articles">{content.common.viewMore}</button>
      </div>
    </section>
  );
};
